import { Component, OnInit, Input } from '@angular/core';

  @Component({
    selector: 'list-next-ttt',
    templateUrl: './a-list-next.component.html',
})
export class AListNextComponent implements OnInit {
    @Input() md: any;
    @Input() nql: any;
    @Input() main_language_flg:number;

    constructor() { }

    ngOnInit() {
    }
    addRow(row:number) : void{
        let sss={
            question_id: null,
            question_text: null,
        };
        this.md.splice(row+1, 0, sss); // i番目の次に１レコード追加
    }
    delRow(row:number) : void{
        this.md.splice(row, 1); // i番目を１レコード削除
    }
    upRow(row:number) : void{
        if (row==0){//最初

        }else{
            this.md.splice(row-1, 2, this.md[row], this.md[row-1]);
        }
    }
    downRow(row:number) : void{
        if (row==this.md.length-1){//最終

        }else{
            this.md.splice(row, 2, this.md[row+1], this.md[row]);
        }
    }
    includedList(id:string):boolean{
        var row = this.nql.filter(
            item => 
            item.question_id==id
          );  
        if (row.length>0){
            return true;
        }else{
            return false;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/a0103-question-register/a-list-next.component.ts